import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberService, PublicInfoResponse } from '@app/core/members/member.service';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { V2AuthAbstract } from '@app/+login/deprecated-hybrid/v2-auth.abstract.component';
import { LoginV2CommonService } from '@app/+login/deprecated-hybrid/login-v2-common.service';
import { SettingsService } from '@app/core/settings/settings.service';
import { isEmail } from '@app/+login/deprecated-hybrid/helpers';
import { INVALID_EMAIL_ERROR_KEY } from '../../consts';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { PageTitleComponent } from '@app/+login/deprecated-hybrid/components/page-title/page-title.component';

const REGISTERED_IDENTIFIER_ERROR_KEY = 'registered_identifier';

@Component({
  selector: 'app-hybrid-signup',
  templateUrl: './hybrid-signup.component.html',
  imports: [
    TranslatePipe,
    AsyncPipe,
    ReactiveFormsModule,
    InputErrorsComponent,
    FormsModule,
    PageTitleComponent,
  ],
})
export class HybridSignupComponent extends V2AuthAbstract {
  constructor(cdr: ChangeDetectorRef,
              memberService: MemberService,
              settingsService: SettingsService,
              route: ActivatedRoute,
              router: Router,
              private common: LoginV2CommonService) {
    super(cdr, route, router, memberService, settingsService);
  }

  public verifyPublicInfo(identifier: MemberIdentifier, publicInfo: PublicInfoResponse): void {
    if (publicInfo.exists) {
      this.submitted = true;
      this.formErrors = { error: REGISTERED_IDENTIFIER_ERROR_KEY };
      this.cdr.detectChanges();
    } else {
      this.common.navigateToAuthPage(['confirmation'], identifier, this.route, publicInfo);
    }
  }

  public navigateToLoginPage(): void {
    this.router.navigate(['..'], { state: { identifierValue: this.formControl.value }, relativeTo: this.route });
  }

  public handleEmailSubmit(value: any): void {
    if (!isEmail(value)) {
      this.formErrors = { error: INVALID_EMAIL_ERROR_KEY, identifier: value };
      return;
    }

    super.handleEmailSubmit(value);
  }
}
